import { render, staticRenderFns } from "./voluntaryRecruitmentDetail.vue?vue&type=template&id=3ed686c6&scoped=true&"
import script from "./voluntaryRecruitmentDetail.vue?vue&type=script&lang=js&"
export * from "./voluntaryRecruitmentDetail.vue?vue&type=script&lang=js&"
import style0 from "./voluntaryRecruitmentDetail.vue?vue&type=style&index=0&id=3ed686c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed686c6",
  null
  
)

export default component.exports